module.exports = __webpack_public_path__ + "static/media/success-svg.d29f1779.svg";